var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<timeout-countdown event=\"event\" model-details=\"modelDetails\" on-confirm=\"ok\" on-error=\"cancel\"></timeout-countdown>\n</div>";
var id1="timeoutCountdown.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/modal/templates/timeoutCountdown.html
// module id = 2622
// module chunks = 1